import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormGroup } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { DealStatus } from 'app/models/dto/deal-status.model';

interface StatusReason {
  reason: string[];
  otherReason: string;
  subReasons: string[];
}

interface DialogData {
  previousOption: DealStatus;
  selectedOption: DealStatus;
}

@Component({
  selector: 'app-deal-status-reason-dialog',
  templateUrl: './deal-status-reason-dialog.component.html',
  styleUrls: ['./deal-status-reason-dialog.component.scss']
})

export class DealStatusReasonDialogComponent implements OnInit {
  form: UntypedFormGroup;
  model: StatusReason;
  fields: FormlyFieldConfig[];
  confirmed = true;
  pppSuspectedFraud = ['Fraudulent IRS Documents', 'Fraudulent Bank Statements', 'Fraudulent ID', 'Lender Declined'];
  hiddenOptions = ['Embedded application expired'];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) { }

  ngOnInit(): void {
    this.initConfirm();
    this.initForm();
  }

  initConfirm() {
    this.confirmed = this.data.previousOption.stage !== 'funded';
  }

  onSelectReason(field, $event): void {
    // if PPP Selected Fraud OR PPP Does Not Qualify is selected, we can only have that selected
    if ($event.value.includes('PPP Suspected Fraud')) {
      this.model = {
          ...this.model,
          reason: ['PPP Suspected Fraud']
      };
    } else if ($event.value.includes('PPP Does Not Qualify')) {
      this.model = {
        ...this.model,
        reason: ['PPP Does Not Qualify'],
        subReasons: ['Required Documents Not Provided'],
      };
    } else {
      this.model = {
        ...this.model,
        subReasons: [],
        otherReason: ''
      };
    }
    this.setReasonOptions();
  }

  setReasonOptions() {
      if (!this.fields[0]?.templateOptions?.options) {
        return;
      }

      this.fields[0].templateOptions.options =  this.data.selectedOption.reasonOptions.map(x => ({
          value: x,
          label: x,
          disabled: (x !== 'PPP Suspected Fraud' && this.model.reason.includes('PPP Suspected Fraud')) ||
                    (x !== 'PPP Does Not Qualify' && this.model.reason.includes('PPP Does Not Qualify'))
      }));
  }

  initForm() {
    this.form = new UntypedFormGroup({});
    this.model = { reason: [], otherReason: '', subReasons: [] };
    this.fields = [
      {
        key: 'reason',
        type: 'select',
        templateOptions: {
          label: 'Reason',
          required: true,
          multiple: true,
          change: this.onSelectReason.bind(this),
          options: this.data.selectedOption.reasonOptions.map(x => ({
              value: x,
              label: x
          })).filter(x => !this.hiddenOptions.includes(x.value)),
        },
      },
      {
          key: 'subReasons',
          type: 'select',
          templateOptions: {
            label: 'Reason(s)',
            required: true,
            multiple: true,
            options: this.pppSuspectedFraud
              .map(x => ({ value: x, label: x })),
          },
          hideExpression: '!model.reason.includes(\'PPP Suspected Fraud\')'
      },
      {
        key: 'otherReason',
        type: 'textarea',
        templateOptions: {
          label: 'Other Reason',
          required: this.model.reason.includes('Other'),
          attributes: {
            'data-cy': 'otherReasonSelect'
          },
        },
        hideExpression: '!model.reason.includes(\'Other\') && !model.reason.includes(\'PPP Suspected Fraud\')'
      },
    ];
  }
}
